(ns pfo.signature.controller
  (:require-macros [pfo.macros :refer [defcontroller]])
  (:require [keechma.next.controller :as ctrl]
            [pfo.api :as api  :refer [process-error]]
            [promesa.core :as p]))

(defcontroller signature
  [{:keys [state*] :as ctrl} event params]
  (case event
    :sign (let [{:keys [token on-success on-error]} params]
            (->>
                 (api/ajaxp (str "/signature/sign/" token "/") {})
                 (p/map on-success)
                 (p/error (fn [e] (if on-error (on-error e) (throw e))))
                 (process-error)))
    :remind (let [{:keys [signer-id]} params](->>
              (api/ajaxp "/signature/remind/" {:method :post
                                               :params {:signer_id signer-id}})
              (process-error)))
    :remind-all (let [{:keys [signature-id]} params]
                  (->>
                    (api/ajaxp "/signature/remindall/" {:method :post
                                                        :params {:signature_id signature-id}})
                    (process-error)))
    :view (let [{:keys [token on-success on-error]} params]
            (->>
              (api/ajaxp (str "/signature/view/" token "/") {})
              (p/map on-success)
              (p/error (fn [e] (if on-error (on-error e) (throw e))))
              (process-error)))
    :link (let [{:keys [task-id complete-by on-success]} params]
            (->>
              (api/ajaxp (str "/signature/link/") {:params {:task_id task-id
                                                            :complete_by complete-by}})
              (p/map (fn [link-info]
                       (ctrl/transact ctrl #(reset! state* link-info))
                       (some-> on-success (apply [link-info]))))
              (process-error)))
    :clear (reset! state* nil)
    nil))
